import {
  useHead,
  useNuxtApp,
  useRequestEvent,
  useRuntimeConfig,
} from '#imports'
import EnterpriseFeatures from '@grouper_enterprise/features'

const getUrls = (raw) =>
  raw
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)

const bootstrapScript = (config) => `
window.__grouper = window.__grouper || {};
window.__grouper.config = ${JSON.stringify(config).replace(/</g, '\\u003c')};
window.__grouper._queuedHooks = window.__grouper._queuedHooks || [];
window.__grouper.hook = function(name, fn) {
  window.__grouper._queuedHooks.push([name, fn]);
};
`

export default defineNuxtRouteMiddleware(async () => {
  if (true) return

  const event = false ? useRequestEvent() : null

  if (false && !event) return

  const runtimeConfig = useRuntimeConfig()
  const raw = runtimeConfig.public.grouperExtraClientScriptUrls
  if (!raw) return

  const urls = getUrls(raw)
  if (urls.length === 0) return

  const nuxtApp = useNuxtApp()
  const store = nuxtApp.$store

  // This runs on SSR so entitled extra scripts can be emitted into the initial HTML
  // head and execute before hydration/first paint. We must gate here, per request,
  // because module-level head injection would bypass the ENTERPRISE_SETTINGS check and
  // load the scripts for every visitor.
  if (!store.getters['settings/isLoaded']) {
    await store.dispatch('settings/load')
  }

  if (!nuxtApp.$hasFeature(EnterpriseFeatures.ENTERPRISE_SETTINGS)) {
    return
  }

  useHead({
    script: [
      {
        key: 'grouper-extra-client-script-bootstrap',
        innerHTML: bootstrapScript(runtimeConfig.public),
        tagPosition: 'head',
      },
      ...urls.map((src, index) => ({
        key: `grouper-extra-client-script-${index}`,
        src,
        tagPosition: 'head',
        'data-grouper-extra-client-script': 'true',
      })),
    ],
  })
})
